module.exports = __webpack_public_path__ + "53e42e3b2a95cca1a31efd4b710dc814.png";